import React from "react";
import { Row, Col } from "react-flexbox-grid";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { withStyles } from "@material-ui/core/styles";
import StatsEditModal from "./stats-edit-modal";

const TYPING = {
  MEN: "HOMBRES",
  WOMEN: "MUJERES",
  TOTAL: "TOTAL",
  URBAN: "URBANA",
  RURAL: "RURAL",
};

const styles = theme => ({
  fab: {
    margin: theme.spacing.unit
  }
});

const StatisticsRow = ({ row, classes, query, variables }) => (
  <TableRow key={row.id}>
    <TableCell>{row.resource.name}</TableCell>
    <TableCell align="right">{row.indicator.name}</TableCell>
    <TableCell align="right">{row.year}</TableCell>
    <TableCell align="right">{TYPING[row.typing] || row.typing}</TableCell>
    <TableCell align="right">{row.value}</TableCell>
    <TableCell align="right">{row.probabilityValue}</TableCell>
    <TableCell align="right">{row.description}</TableCell>
    <TableCell align="right">
      <Row>
        <Col xs={6}>
          <StatsEditModal row={row} query={query} variables={variables} />
        </Col>
        {/*<Col xs={6}>
          <Fab size="small" aria-label="Delete" className={classes.fab}>
            <DeleteIcon />
          </Fab>
        </Col>*/}
      </Row>
    </TableCell>
  </TableRow>
);

export default withStyles(styles)(StatisticsRow);



// WEBPACK FOOTER //
// ./src/components/stats/stats-row.js